import createReducer from '../createReducer';
import {
  FETCH_IDEAL_CONDITIONS,
  FETCH_IDEAL_CONDITIONS_SUCCESS,
  FETCH_IDEAL_CONDITIONS_FAILURE,
} from '../../actions/spot';

const initialState = {};

const handlers = {};

handlers[FETCH_IDEAL_CONDITIONS] = (state) => ({
  ...state,
  loading: true,
});

handlers[FETCH_IDEAL_CONDITIONS_SUCCESS] = (state, { idealConditions }) => ({
  ...state,
  surf: idealConditions.size,
  swell: idealConditions.swell,
  tide: idealConditions.tide,
  wind: idealConditions.wind,
  loading: false,
});

handlers[FETCH_IDEAL_CONDITIONS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);
